/**
 * Created by StoneWang on 2020/11/27.
 */
import {
  config,
  request,
} from 'Utils';

//列表
export function advertList(param) {
  return request(`${config.server}/api/v1/dms/advertPublish/advertList`, {
    method: 'post',
    body: param,
  });
}

/*新增*/
export function addAdvertPublish(param) {
  return request(`${config.server}/api/v1/dms/advertPublish/addAdvertPublish`, {
    method: 'post',
    body: param,
  });
}

/*修改*/
export function modifyAdvertPublish(param) {
  return request(`${config.server}/api/v1/dms/advertPublish/modifyAdvertPublish`, {
    method: 'post',
    body: param,
  });
}

// 详情
export function advertDetail(param) {
  return request(`${config.server}/api/v1/dms/advertPublish/advertDetail`, {
    body: param,
  });
}
// 门户和商城banner轮播图
export function bannerAdvertList(type) {
  return request(`${config.server}/api/v1/dms/advertPublish/bannerAdvertList`, {
    method: 'post',
    body: {
      type: type || 2, //1、门户，2、商城
    },
  });
}

/**
 * {"ids":["1"],"status":1}
 * 备注：status：2 删除， 1 启用， 0禁用
 * */
export function updateStatus(param) {
  return request(`${config.server}/api/v1/dms/advertPublish/updateStatus`, {
    method: 'post',
    body: param,
  });
}



// WEBPACK FOOTER //
// ./src/service/carousel/index.js